import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardFooter } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { Eye, ShieldCheck, ShieldAlert } from 'lucide-react';

export const ProductCard = ({ product }) => {
  const navigate = useNavigate();

  return (
    <Card className="group overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-1 border-gray-200 bg-white">
      <div className="relative overflow-hidden bg-gradient-to-br from-blue-50 to-gray-50 h-48">
        <img
          src={product.image}
          alt={product.name}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute top-3 right-3 flex flex-col gap-2">
          <Badge 
            variant={product.inStock ? "default" : "secondary"} 
            className={product.inStock ? "bg-green-500 hover:bg-green-600" : "bg-gray-400"}
          >
            {product.inStock ? "In Stock" : "Out of Stock"}
          </Badge>
          {product.prescription && (
            <Badge variant="destructive" className="bg-red-500 flex items-center gap-1">
              <ShieldAlert className="h-3 w-3" />
              Rx
            </Badge>
          )}
        </div>
      </div>

      <CardContent className="pt-5 pb-3">
        <div className="mb-2">
          <Badge variant="outline" className="text-xs text-blue-700 border-blue-300 bg-blue-50">
            {product.category}
          </Badge>
        </div>
        <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-1">
          {product.name}
        </h3>
        <p className="text-sm text-gray-600 line-clamp-2 mb-3">
          {product.description}
        </p>
        <div className="flex items-center text-xs text-gray-500 gap-1">
          <ShieldCheck className="h-3.5 w-3.5 text-blue-600" />
          <span>Quality Assured</span>
        </div>
      </CardContent>

      <CardFooter className="pt-0 pb-4">
        <Button
          onClick={() => navigate(`/product/${product.id}`)}
          className="w-full bg-blue-600 hover:bg-blue-700 transition-all group/btn"
        >
          <Eye className="h-4 w-4 mr-2 transition-transform group-hover/btn:scale-110" />
          View Details
        </Button>
      </CardFooter>
    </Card>
  );
};
